import DiscordIcon from "@/common/images/icons/socials/discord.svg?react";
import RedditIcon from "@/common/images/icons/socials/reddit.svg?react";
import XIcon from "@/common/images/icons/socials/twitter.svg?react";
import InstagramIcon from "@/common/images/icons/socials/instagram.svg?react";

export const SOCIALS = [
  {
    Icon: DiscordIcon,
    link: "https://discord.gg/w8fTWPn4Eb",
    title: "Discord",
  },
  {
    Icon: XIcon,
    link: "https://bit.ly/405Qdey",
    title: "X",
  },
  {
    Icon: InstagramIcon,
    link: "https://bit.ly/3naK6an",
    title: "Instagram",
  },
  {
    Icon: RedditIcon,
    link: "http://bit.ly/405rRS7",
    title: "Reddit",
  }
];
